import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';

const StoreListTopContent = (_param)=> {
    var { title , description , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "title",
        "description",
        "className"
    ]);
    return React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-list-top-content-stores-v2', className)
    }), title && /*#__PURE__*/ React__default.createElement("h2", {
        className: "h3"
    }, title), description && /*#__PURE__*/ React__default.createElement("p", {
        "data-t": "store-list-top-content-description"
    }, description));
};
var StoreListTopContent$1 = StoreListTopContent;

export { StoreListTopContent$1 as default };
//# sourceMappingURL=StoreListTopContent.js.map
